import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import classNames from 'classnames'

// components
import NioField from '../../../NioField/NioField';
import NioCard from '../../../Cards/NioCard/NioCard';
import NioButton from '../../../NioButton/NioButton';
import NioToaster from '../../../NioToaster/NioToaster';
import useRouteMatch from '../../../../hooks/useRouteMatch';
import api from '../../../../utils/api';


export default function ContactForm() {

  const [status, setStatus] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const { register, handleSubmit, reset, formState: { errors } } = useForm();


  const onSubmit = async (data) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.submitContact({
        name: data.name,
        email: data.email,
        subject: data.phone || 'Contact Form Submission',
        message: data.message
      })

      if (response.success) {
        setStatus(true)
        reset()
      }
    } catch (err) {
      setError(err.message || 'Failed to submit contact form. Please try again.')
      console.error('Contact form submission error:', err)
    } finally {
      setLoading(false)
    }
  }

  // Classes 
  const fieldWrapper = classNames({
    "form-control-wrap": true
  });

  return (
    <>
      <NioCard className="rounded-2">
        <NioCard.Body>
          <form onSubmit={handleSubmit(onSubmit)} className="form-submit-init">
            <Row className="g-gs">
              <Col xs={12}>
                <NioField label="Full Name" htmlFor="fname">
                  <NioField.Input id="fname" placeholder="Enter Your Name" errors={errors.name} {...register("name", {
                    required: "field is required"
                  })} />
                </NioField>
              </Col>
              <Col lg={6}>
                <NioField label="Email" htmlFor="email">
                  <NioField.Input type="email" id="email" placeholder="Enter Your Email" errors={errors.email} {...register("email", {
                    required: "field is required",
                    pattern: {
                      value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "invalid email address"
                    }
                  })} />
                </NioField>
              </Col>
              <Col lg={6}>
                <NioField label="Phone" htmlFor="phone">
                  <NioField.Input type="number" id="phone" placeholder="(223) 456 - 789" errors={errors.phone} {...register("phone", {
                    required: "field is required"
                  })} />
                </NioField>
              </Col>
              <Col xs={12}>
                <div className="form-group">
                  <div className="form-label-group">
                    <label className="form-label">Tell us a bit about your query</label>
                    <span>
                      <span id="char-count">0</span>/ <span id="char-max" data-char-max="255">255</span>
                    </span>
                  </div>
                  {/*  .form-label-group  */}
                  <div className={fieldWrapper}>
                    <textarea
                      className="form-control"
                      placeholder="Enter your message"
                      {...register("message")}
                    ></textarea>
                  </div>
                </div>
              </Col>
              <Col xs={12}>
                <div className="form-group">
                  <NioButton 
                    className={useRouteMatch(["/contact-us"]) ? 'btn-primary' : 'btn-indigo'} 
                    label={loading ? 'Sending...' : 'Send Message'}
                    disabled={loading}
                    type="submit"
                  />
                </div>
              </Col>
            </Row>
          </form>
        </NioCard.Body>
      </NioCard>
      {status && <NioToaster variant="success text-white" messages={[{ id: 1, header: 'Success', body: 'We have successfully received your message. We will get back to you soon.' }]} />}
      {error && <NioToaster variant="danger text-white" messages={[{ id: 2, header: 'Error', body: error }]} />}
    </>
  )
}
